import axios from 'axios';

import { redirect2LoginPage } from "./const/redirectUri";
import { doCheckAndRestStorageInfo } from "./api/auth";

var instance = axios.create({
    withCredentials: true
});


instance.interceptors.request.use(
    config => {
        doCheckAndRestStorageInfo();
        let token = localStorage.getItem('token');
        config.headers.common.Authorization = 'Bearer ' + token;
        config.headers.common.mainId = localStorage.getItem('_mainId');
        config.headers.common.uid = localStorage.getItem('_uid');
        if (localStorage.getItem('_mainId') == null || localStorage.getItem('_mainId') == '') {
            location.hash = "/auth";
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//axios response 拦截器
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && (error.response.status === 403 || error.response.code == '5000')) {
            if (error.config && error.config.skipRedirect) {
                return Promise.reject(error);
            }
            redirect2LoginPage();
        } else {
            return Promise.reject(error)
        }
    }
);

export default instance;
